import { render, staticRenderFns } from "./viewLog.vue?vue&type=template&id=4b688537&scoped=true"
import script from "./viewLog.vue?vue&type=script&lang=js"
export * from "./viewLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b688537",
  null
  
)

export default component.exports